<template>
  <div
    id="modalRfbError"
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalRfbMessageError"
    aria-hidden="true"
  >
    <div class="modal-dialog text-start">
      <div class="modal-content">
        <div class="modal-header">
          <h1 id="modalRfbMessageError" class="modal-title fs-5 color--danger">
            Ops, algo deu errado
          </h1>
          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Fechar"
          ></button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-center">
            <img
              class="image"
              style="height: 186px"
              src="@/assets/images/worried-girl.svg"
              alt="Menina confusa, erro de consulta RFB"
            />
          </div>
          <div>
            <p class="fw-600">
              Algo deu errado ao consultar seu Pedido/<br />Voucher.
            </p>
            <p>
              Por favor,
              <span class="fw-600">entre em contato com o fornecedor.</span>
            </p>
            <p>Obrigado por sua compreensão!</p>
          </div>
        </div>

        <div class="modal-footer border-top-1">
          <button
            class="btn-fechar btn modal-footer_btn-process btn-primary"
            type="button"
            @click="modalClose"
          >
            <span>Fechar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { Modal } from 'bootstrap'

  export default defineComponent({
    name: 'ModalRFBError',
    data: () => ({
      model: {
        cnpj: '',
      },
      modal: null as any,
      error: '',
    }),
    mounted() {
      const modal = document.getElementById('modalRfbError') as HTMLElement
      this.modal = new Modal(modal, {})
    },
    methods: {
      modalOpen() {
        this.modal.show()
      },
      modalClose() {
        this.modal.hide()
      },
    },
  })
</script>

<style lang="stylus" scoped>
  p
   margin: 8px 0 0 0

  .modal-body
    padding: 24px !important
  .btn-modal
    opacity: 0

  #modalRfbError
    .modal-dialog
      max-width: 400px

  @media screen and (max-width: 576px)
    .modal-dialog
      height: auto
      margin: 0.5rem
    .modal-content
      border-radius: 0.5rem
</style>
